import { createAction, props } from '@ngrx/store';

export const addRecentPolicy = createAction(
    '[RecentPolicies] Add Policy',
    props<{ policyNumber: string; lineOfBusiness: string }>()
);

export const clearRecentPolicies = createAction('[RecentPolicies] Clear');
